import styled from 'styled-components/macro';
import { blueProgressBar } from '../../styles/colors';
import media from '../../styles/media';

export const ProgressBar = styled.progress`
  width: 100%;
  height: 4px;
  appearance: none;
  background-color: ${blueProgressBar};
  border-radius: 2px;
  border-color: ${blueProgressBar};
  border-width: 0;

  ::-webkit-progress-bar {
    background-color: ${blueProgressBar};
    border-radius: 2px;
  }
  ::-webkit-progress-value {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.secondaryColor};
    transition: width 0.5s ease;
  }
  ::-moz-progress-bar {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.secondaryColor};
    transition: width 0.5s ease;
  }
  ::-ms-fill {
    background-color: ${({ theme }) => theme.secondaryColor};
    border: 0;
  }

  ${media.desktop`
    margin: auto;
  `}
`;
